const PATIENT_CONTEXT = 'patient';
const CONSULTATION_CONTEXT = 'consultation';
export const getCorrectFieldIdFromContext = (context: string, id: string, examType = '') => {
  switch (context) {
    case PATIENT_CONTEXT:
      return `${context}-${id}`;
    case CONSULTATION_CONTEXT:
      return `${context}-${examType}-${id}`;
    default:
      return id;
  }
};
